import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';

var getTestId = function getTestId(testId, suffix) {
  if (!testId) return undefined;
  if (!suffix) return testId;
  return _concatInstanceProperty(testId).call(testId, "--".concat(suffix));
};

export { getTestId };
//# sourceMappingURL=testId.js.map
